export const kimchiPremiumPaths = {
  markets: '/api/v1/kimchi-premium/markets',
  current: '/api/v1/kimchi-premium/current',
  chart: (coinCode: string) => `/api/v1/kimchi-premium/${coinCode}/chart`,
  /** TRAD-3709 P2 · backend TRAD-3719 — 일간 요약. */
  daily: (date: string) => `/api/v1/kimchi-premium/daily/${date}`,
} as const;
